import { Link } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import { blogPosts } from "../data/products";
import { getBlog, getALLblog } from "../services/blogService";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useInquiry } from "../context/InquiryContext";

export default function BlogDetailsPage() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recentPosts, setRecentPosts] = useState([]);
  useEffect(() => {
    const fetchPostDetails = async () => {
      try {
        setLoading(true);

        const res = await getBlog(id);
        setPost(res.data.data || res.data);

        const allRes = await getALLblog();
        const allBlogs = allRes.data.data || allRes.data;

        setRecentPosts(allBlogs.filter((b) => b.blog_id !== id).slice(0, 3));
      } catch (error) {
        console.error("Error fetching blog post details:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchPostDetails();
  }, [id]);
  if (loading) {
    return (
      <div className="flex items-center justify-center py-32">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-[#CAE4C9]" />
      </div>
    );
  }
  if (!post) return <div className="text-center py-8">Post not found.</div>;

  return (
    <div>
      <div
        className="w-full h-32 bg-cover bg-center relative flex items-center p-8 border-b border-gray-100 overflow-hidden"
        style={{ backgroundImage: "url(/img/bg/banner18.jpg)" }}
      >
        <nav className="text-xs text-gray-400 font-medium tracking-wide justify-center items-center m-auto text-center">
          <h2 className="text-2xl text-black font-semibold mb-2">Blog</h2>
          <Link to="/" className="hover:text-[#43a047] transition-colors">
            Home
          </Link>
          <span className="mx-2 text-gray-300">/</span>
          <span className="text-gray-600">Blog Details</span>
        </nav>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Main */}
          <article className="flex-1">
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-72 object-cover mb-6"
            />
            {/* <div className="mb-4 flex gap-3 text-xs text-gray-400">
              <span>{post.date}</span>
              <span>|</span>
              <Link to="/blog" className="text-primary hover:underline">
                {post.cat}
              </Link>
              <span>|</span>
              <span>By {post.author}</span>
            </div> */}
            <h1 className="text-2xl font-bold text-dark mb-5 leading-tight">
              {post.title}
            </h1>
            <h1 className="text-xl font-semibold text-dark mb-5 leading-tight">
              {post.subject}
            </h1>

            <div
              className="text-sm text-gray-500 leading-relaxed mb-8 raw-html-content"
              dangerouslySetInnerHTML={{ __html: post.description }}
            />
            {/* <div className="text-sm text-gray-500 leading-relaxed space-y-4 mb-8">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                nisl eros, pulvinar facilisis justo mollis, auctor consequat
                urna. Morbi a bibendum metus.
              </p>
              <p>
                Donec scelerisque sollicitudin enim eu venenatis. Nullam blandit
                eros nibh, sed elementum velit fringilla eu. Sed rhoncus augue
                vel mi tempus efficitur. Vestibulum congue libero vel leo
                facilisis.
              </p>
              <blockquote className="border-l-4 border-primary pl-4 py-2 italic text-dark bg-gray-50">
                "Natural organic foods are the best gift you can give to your
                family's health."
              </blockquote>
              <p>
                Maecenas nunc lacus, condimentum non nibh vel, pretium eleifend
                metus. Nunc maximus quam augue, non blandit libero finibus
                vitae. Phasellus efficitur dui eu lorem laoreet pellentesque.
              </p>
            </div> */}

            {/* Tags */}
            {/* <div className="flex flex-wrap gap-2 mb-8 pt-4 border-t border-border-color">
              <span className="text-sm font-medium text-dark mr-2">Tags:</span>
              {["Organic", "Fresh", "Healthy"].map((tag) => (
                <a
                  key={tag}
                  href="#"
                  className="text-xs border border-border-color px-2.5 py-1 text-gray-500 hover:bg-primary hover:text-white hover:border-primary transition-colors"
                >
                  {tag}
                </a>
              ))}
            </div> */}

            {/* Comments */}
            {/* <div className="mt-8">
              <h3 className="text-lg font-bold text-dark mb-6">
                Leave a Comment
              </h3>
              <div className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Your Name *"
                    className="border border-border-color px-4 py-2.5 text-sm outline-none focus:border-primary"
                  />
                  <input
                    type="email"
                    placeholder="Your Email *"
                    className="border border-border-color px-4 py-2.5 text-sm outline-none focus:border-primary"
                  />
                </div>
                <textarea
                  rows={5}
                  placeholder="Your Comment *"
                  className="w-full border border-border-color px-4 py-2.5 text-sm outline-none focus:border-primary resize-none"
                />
                <button className="btn-primary">Post Comment</button>
              </div>
            </div> */}
          </article>

          {/* Sidebar */}
          <aside className="lg:w-72 flex-shrink-0 space-y-8">
            <div>
              <div className="space-y-4">
                {recentPosts.map((p) => (
                  <div key={p.blog_id} className="flex gap-3 items-start">
                    <Link to={`/blog-details/${p.blog_id}`}>
                      <img
                        src={p.full_image_url || p.image}
                        alt={p.title}
                        className="w-16 h-16 object-cover border border-border-color flex-shrink-0"
                      />
                    </Link>
                    <div>
                      <Link
                        to={`/blog-details/${p.blog_id}`}
                        className="text-xs font-medium text-dark hover:text-primary leading-snug line-clamp-2"
                      >
                        {p.title}
                      </Link>
                      <p className="text-xs text-gray-400 mt-1">
                        {new Date(p.created_at).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="font-bold text-dark mb-4 pb-2 border-b border-border-color uppercase text-sm tracking-wider">
                Tags
              </h3>
              <div className="flex flex-wrap gap-2">
                {[
                  "Organic",
                  "Fresh",
                  "Vegetables",
                  "Fruits",
                  "Natural",
                  "Farm",
                ].map((tag) => (
                  <a
                    key={tag}
                    href="#"
                    className="text-xs border border-border-color px-2.5 py-1 text-gray-500 hover:bg-[#CAE1C3] hover:text-black hover:border-primary transition-colors"
                  >
                    {tag}
                  </a>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}
